module.exports = __webpack_public_path__ + "static/piantinaB-8f387d6bd75126c9248f6d335260a08b.png";